import React from 'react';
import { Page, Section } from '@parchment/ui-primitives';
import { SearchOrCreate } from '@parchment/ui-search-or-create';
import { default as Individual } from '@parchment/ui-icons/lib/ai/individual-1';
import { default as Group } from '@parchment/ui-icons/lib/ai/third-party';
import InstitutionPage from '../containers/InstitutionContainer';
import P6LearnerLandingPage from './P6LearnerLandingPage';
import '../style/LandingPage.less';

const isTpoEnabled = window.config.member.tpoEnabled;
const p6Landing = typeof window.config.member.learnerOrderingUri === 'string';
const TPO_HASH_PATH = /^#\/tpo/;

export default class LandingPage extends Page {
    static get propTypes() {
        return { ...super.propTypes

        };
    }

    static get defaultProps() {
        let title = "Sign Up For A Free Parchment Account";
        if(p6Landing) {
            title = 'You Selected';
        }
        return { ...super.defaultProps,
            title,
            onCancel: () => window.location.href = '/'
        };
    }

    get onBack() {
        let backUrl = `/u/registration/${this.props.params.memberId}/account`;
        if(p6Landing) {
            backUrl = '/';
        }
        return () => {
            window.location.href = backUrl;
        };
    }

    constructor(props) {
        super(props);

        this.handleOptionChange = this.handleOptionChange.bind(this);

        const hashPath = window.location.hash || '#';

        if(p6Landing) {
            this.state = {...this.state,
                selectedTab: hashPath.match(TPO_HASH_PATH) && isTpoEnabled ?
                    SearchOrCreate.CREATE : SearchOrCreate.SEARCH
            };
        }
    }

    getPageClass() {
        return 'narrow-width';
    }

    handleOptionChange(selectedTab) {
        this.setState({selectedTab});
    }

    renderTabContents() {
        if(this.state.selectedTab === SearchOrCreate.SEARCH) {
            return (<P6LearnerLandingPage
                learnerOrderingUri={window.config.member.learnerOrderingUri} />);
        } else {
            return (<InstitutionPage
                {...this.props} />);
        }
    }

    renderContents() {
        if(p6Landing) {
            const learnerTabIcon = (<div className="learner-icon-option option-icon"><Individual/></div>);
            const tpoTabIcon = (<div className="tpo-icon-option option-icon"><Group /></div>);
            return (<div className="landing-page-inner-container">
                <Section additionalClasses="radio-group">
                    <SearchOrCreate
                        selectedOption={this.state.selectedTab}
                        onChange={this.handleOptionChange}
                        searchLabel={<div className="radio-button-option-label">
                            I need to order<br />
                            my own credentials
                        </div>}
                        searchIcon={learnerTabIcon}
                        searchIconSelected={learnerTabIcon}
                        createLabel={<div className="radio-button-option-label">
                            I need to order<br />
                            someone else's credentials<br />
                            <span className="note-text">(Authorization is required)</span>
                        </div>}
                        createIcon={tpoTabIcon}
                        createIconSelected={tpoTabIcon}
                        createEnabled={isTpoEnabled}
                    />
                </Section>
                {this.renderTabContents()}
            </div>);
        } else {
            return (<InstitutionPage
                {...this.props} />);
        }
    }

    getBody() {
        return (<div className="landing-page-container">
            {this.renderContents()}
        </div>);
    }

}
